import { Dispatch } from 'redux'

import { create, destroy, getAll, update } from 'redux/api/AllocationKeys'

import {
  IPatchAllocationKey,
  IPostAllocationKey
} from 'types/GlobalAllocationKey'
import { toggleSnackbarOpen } from '../Snackbar'
import { SnackbarMessage } from 'types/GlobalSnackbar'

import { useThunkActions } from 'redux/actions/useThunkActions'

import * as actions from './actions'

export function tryCreateAllocationKey(
  data: IPostAllocationKey,
  callback: (err?: boolean) => void
) {
  return (dispatch: Dispatch) => {
    dispatch(actions.create())

    create({ data })
      .then((response) => {
        dispatch(actions.createSuccess(response.data))

        dispatch(toggleSnackbarOpen(SnackbarMessage.Success))

        callback()
      })
      .catch(() => {
        dispatch(actions.createFailed())

        dispatch(toggleSnackbarOpen(SnackbarMessage.Failed))

        callback(true)
      })
  }
}

export function tryUpdateAllocationKey(
  id: string,
  data: IPatchAllocationKey,
  callback: (err?: boolean) => void
) {
  return (dispatch: Dispatch) => {
    dispatch(actions.update())

    update(id, { data })
      .then((response) => {
        dispatch(actions.updateSuccess(response.data))

        dispatch(toggleSnackbarOpen(SnackbarMessage.Success))

        callback()
      })
      .catch(() => {
        dispatch(actions.updateFailed())

        dispatch(toggleSnackbarOpen(SnackbarMessage.Failed))

        callback(true)
      })
  }
}

export function tryGetAllAllocationKeys() {
  return (dispatch: Dispatch) => {
    dispatch(actions.getAll())

    getAll()
      .then((response) => {
        dispatch(actions.getAllSuccess(response.data))
      })
      .catch(() => {
        dispatch(actions.getAllFailed())
      })
  }
}

export function tryDeleteAllocationKey(
  id: string,
  callback: (err?: boolean) => void
) {
  return (dispatch: Dispatch) => {
    dispatch(actions.destroy())

    destroy(id)
      .then(() => {
        dispatch(actions.destroySuccess(id))

        dispatch(toggleSnackbarOpen(SnackbarMessage.Success))

        callback()
      })
      .catch(() => {
        dispatch(actions.destroyFailed())

        dispatch(toggleSnackbarOpen(SnackbarMessage.Failed))

        callback(true)
      })
  }
}

export const useAllocationKeyActions = () => {
  return {
    tryCreateAllocationKey: useThunkActions(tryCreateAllocationKey),
    tryUpdateAllocationKey: useThunkActions(tryUpdateAllocationKey),
    tryGetAllAllocationKeys: useThunkActions(tryGetAllAllocationKeys),
    tryDeleteAllocationKey: useThunkActions(tryDeleteAllocationKey)
  }
}
